module.exports = __webpack_public_path__ + "img/JUNIORLOGO.fffb3f4a.jpg";